// Brand-colored gradient palette (consistent, category-tinted)
const GRADIENTS = {
    fashion: ['#ff6b9d', '#c84b7e'],
    food: ['#ff9a3c', '#e85a19'],
    entertainment: ['#7850ff', '#4a2dbd'],
    travel: ['#38bdf8', '#0369a1'],
    ecommerce: ['#fbbf24', '#d97706'],
    beauty: ['#ec4899', '#be185d'],
    fitness: ['#10b981', '#047857'],
    home: ['#64748b', '#334155'],
    education: ['#6366f1', '#3730a3'],
    utility: ['#14b8a6', '#0f766e']
};

function makeBrand(id, brand, voucher, category, cat, logo = null) {
    const discounts = [3, 5, 6, 8, 10, 12, 15];
    const prices = [250, 500, 1000, 1500, 2000, 2500];
    const discount = discounts[id % discounts.length];
    const price = prices[id % prices.length];
    return {
        id,
        brand,
        voucher,
        category,
        categoryKey: cat,
        price: `₹${price.toLocaleString('en-IN')}`,
        discount: `${discount}% OFF`,
        saved: `₹${Math.round((price * discount) / 100)}`,
        gradient: GRADIENTS[cat],
        initial: brand.replace(/[^A-Za-z]/g, '').charAt(0).toUpperCase(),
        logo: logo
    };
}

export const dtShopCategories = [
    { key: 'fashion',       name: 'Retail / Fashion',    icon: '🛍️' },
    { key: 'food',          name: 'Food & Dining',       icon: '🍔' },
    { key: 'entertainment', name: 'Entertainment & OTT', icon: '🎬' },
    { key: 'travel',        name: 'Travel & Hotels',     icon: '✈️' },
    { key: 'ecommerce',     name: 'E-Commerce',          icon: '🛒' },
    { key: 'beauty',        name: 'Beauty & Personal Care', icon: '💄' },
    { key: 'fitness',       name: 'Fitness & Wellness',  icon: '🏋️' },
    { key: 'home',          name: 'Home & Electronics',  icon: '🏠' },
    { key: 'education',     name: 'Education',           icon: '📚' },
    { key: 'utility',       name: 'Misc / Utility',      icon: '🚗' }
];

let _id = 0;
const b = (brand, voucher, category, cat, logo = null) => makeBrand(++_id, brand, voucher, category, cat, logo);

export const dtShopBrands = [
    // 🛍️ Retail / Fashion / Lifestyle (First 16 shown in Partners marquee)
    b('Nike',            'Nike Gift Card',             'Retail / Fashion', 'fashion', '/logos/nike.png'),
    b('Adidas',          'Adidas Gift Card',           'Retail / Fashion', 'fashion', '/logos/adidas.png'),
    b('Puma',            'Puma E-Gift Card',           'Retail / Fashion', 'fashion', '/logos/puma.png'),
    b('Zara',            'Zara Gift Card',             'Retail / Fashion', 'fashion', '/logos/zara.png'),
    b('H&M',             'H&M Gift Card',              'Retail / Fashion', 'fashion', '/logos/hm.png'),
    b("Levi's",          "Levi's Gift Card",           'Retail / Fashion', 'fashion', '/logos/levis.png'),
    b('Lifestyle',       'Lifestyle E-Gift Voucher',   'Retail / Fashion', 'fashion', '/logos/lifestyle.png'),
    b('Shoppers Stop',   'Shoppers Stop Gift Card',    'Retail / Fashion', 'fashion', '/logos/ss.png'),
    b('Pantaloons',      'Pantaloons Gift Card',       'Retail / Fashion', 'fashion', '/logos/pantaloons.png'),
    b('Westside',        'Westside Gift Card',         'Retail / Fashion', 'fashion', '/logos/westside.png'),
    b('Decathlon',       'Decathlon Gift Card',        'Retail / Fashion', 'fashion', '/logos/decathlon.png'),
    b('FabIndia',        'FabIndia Gift Card',         'Retail / Fashion', 'fashion', '/logos/fabindia.png'),
    b('Bata',            'Bata Gift Card',             'Retail / Fashion', 'fashion', '/logos/bata.png'),
    b('Reliance Trends', 'Trends Gift Card',           'Retail / Fashion', 'fashion', '/logos/reliance.png'),
    b('Ajio',            'Ajio Gift Card',             'Retail / Fashion', 'fashion', '/logos/ajio.png'),

    // 🍔 Food / Dining / Delivery
    b("McDonald's",      "McDonald's Gift Card",       'Food & Dining', 'food', '/logos/mcdonalds.png'),
    b('KFC',             'KFC Gift Voucher',           'Food & Dining', 'food'),
    b("Domino's",        "Domino's E-Gift Card",       'Food & Dining', 'food'),
    b('Pizza Hut',       'Pizza Hut Gift Card',        'Food & Dining', 'food'),
    b('Subway',          'Subway Gift Card',           'Food & Dining', 'food'),
    b('Starbucks',       'Starbucks Gift Card',        'Food & Dining', 'food'),
    b('Barbeque Nation', 'BBQ Nation Voucher',         'Food & Dining', 'food'),
    b('Zomato',          'Zomato Gift Card',           'Food & Dining', 'food'),
    b('Swiggy',          'Swiggy Money Voucher',       'Food & Dining', 'food'),
    b('Cafe Coffee Day', 'CCD Gift Card',              'Food & Dining', 'food'),
    b('Burger King',     'Burger King Gift Card',      'Food & Dining', 'food'),
    b('Bikanervala',     'Bikanervala Voucher',        'Food & Dining', 'food'),
    b('Wow! Momo',       'Wow Momo Gift Card',         'Food & Dining', 'food'),
    b('Taco Bell',       'Taco Bell Gift Card',        'Food & Dining', 'food'),
    b("Dunkin'",         "Dunkin' Gift Card",          'Food & Dining', 'food'),

    // 🎬 Entertainment / OTT / Gaming
    b('Netflix',         'Netflix Gift Card',          'Entertainment & OTT', 'entertainment'),
    b('Amazon Prime',    'Prime Membership Voucher',   'Entertainment & OTT', 'entertainment'),
    b('Disney+ Hotstar', 'Hotstar Subscription Card',  'Entertainment & OTT', 'entertainment'),
    b('Sony LIV',        'Sony LIV Gift Card',         'Entertainment & OTT', 'entertainment'),
    b('Zee5',            'Zee5 Subscription Voucher',  'Entertainment & OTT', 'entertainment'),
    b('Spotify',         'Spotify Gift Card',          'Entertainment & OTT', 'entertainment'),
    b('Google Play',     'Google Play Gift Card',      'Entertainment & OTT', 'entertainment'),
    b('Apple',           'Apple App Store & iTunes',   'Entertainment & OTT', 'entertainment'),
    b('PlayStation',     'PSN Gift Card',              'Entertainment & OTT', 'entertainment'),
    b('Xbox',            'Xbox Gift Card',             'Entertainment & OTT', 'entertainment'),
    b('Steam',           'Steam Wallet Code',          'Entertainment & OTT', 'entertainment'),
    b('BookMyShow',      'BMS Gift Card',              'Entertainment & OTT', 'entertainment'),
    b('PVR',             'PVR Cinemas Gift Card',      'Entertainment & OTT', 'entertainment'),
    b('INOX',            'INOX Gift Card',             'Entertainment & OTT', 'entertainment'),
    b('ShemarooMe',      'Subscription Voucher',       'Entertainment & OTT', 'entertainment'),

    // ✈️ Travel / Hotels
    b('MakeMyTrip',      'MMT Gift Card',              'Travel & Hotels', 'travel'),
    b('Yatra',           'Yatra Gift Voucher',         'Travel & Hotels', 'travel'),
    b('Goibibo',         'Goibibo Gift Card',          'Travel & Hotels', 'travel'),
    b('OYO',             'OYO Rooms Gift Card',        'Travel & Hotels', 'travel'),
    b('Airbnb',          'Airbnb Gift Card',           'Travel & Hotels', 'travel'),
    b('Cleartrip',       'Cleartrip Gift Card',        'Travel & Hotels', 'travel'),
    b('EaseMyTrip',      'EMT Gift Card',              'Travel & Hotels', 'travel'),
    b('Thomas Cook',     'Travel Voucher',             'Travel & Hotels', 'travel'),
    b('Club Mahindra',   'Holiday Voucher',            'Travel & Hotels', 'travel'),
    b('Taj Hotels',      'Taj Experiences Gift Card',  'Travel & Hotels', 'travel'),

    // 🛒 E-Commerce / Marketplaces
    b('Amazon',          'Amazon Pay Gift Card',       'E-Commerce', 'ecommerce'),
    b('Flipkart',        'Flipkart Gift Card',         'E-Commerce', 'ecommerce'),
    b('Myntra',          'Myntra Gift Card',           'E-Commerce', 'ecommerce'),
    b('Snapdeal',        'Snapdeal Gift Card',         'E-Commerce', 'ecommerce'),
    b('Tata CLiQ',       'Tata CLiQ Gift Card',        'E-Commerce', 'ecommerce'),
    b('Nykaa',           'Nykaa Gift Card',            'E-Commerce', 'ecommerce'),
    b('FirstCry',        'FirstCry Gift Card',         'E-Commerce', 'ecommerce'),
    b('Pepperfry',       'Pepperfry Gift Card',        'E-Commerce', 'ecommerce'),
    b('BigBasket',       'BigBasket Gift Card',        'E-Commerce', 'ecommerce'),
    b('Reliance Digital','Reliance Digital Gift Card', 'E-Commerce', 'ecommerce'),

    // 💄 Beauty / Personal Care
    b('Sephora',         'Sephora Gift Card',          'Beauty & Personal Care', 'beauty'),
    b('Nykaa Luxe',      'Nykaa Luxe Gift Card',       'Beauty & Personal Care', 'beauty'),
    b('The Body Shop',   'Body Shop Gift Card',        'Beauty & Personal Care', 'beauty'),
    b('Kama Ayurveda',   'Kama Gift Card',             'Beauty & Personal Care', 'beauty'),
    b('Forest Essentials','Forest Essentials Card',    'Beauty & Personal Care', 'beauty'),
    b('Sugar Cosmetics', 'Sugar Gift Card',            'Beauty & Personal Care', 'beauty'),
    b('Lakmé',           'Lakmé Gift Voucher',         'Beauty & Personal Care', 'beauty'),
    b('Mamaearth',       'Mamaearth Gift Card',        'Beauty & Personal Care', 'beauty'),
    b('Plum',            'Plum Gift Card',             'Beauty & Personal Care', 'beauty'),
    b('Colorbar',        'Colorbar Gift Card',         'Beauty & Personal Care', 'beauty'),

    // 🏋️ Fitness / Wellness
    b('Cult.fit',        'Cult Membership Voucher',    'Fitness & Wellness', 'fitness'),
    b('HealthKart',      'HealthKart Gift Card',       'Fitness & Wellness', 'fitness'),
    b('Decathlon Fitness','Decathlon Voucher',         'Fitness & Wellness', 'fitness'),
    b("Gold's Gym",      'Gold Gym Membership',        'Fitness & Wellness', 'fitness'),
    b('Talwalkars',      'Talwalkars Gym Voucher',     'Fitness & Wellness', 'fitness'),

    // 🏠 Home / Electronics
    b('Croma',           'Croma Gift Card',            'Home & Electronics', 'home'),
    b('Vijay Sales',     'Vijay Sales Gift Card',      'Home & Electronics', 'home'),
    b('IKEA',            'IKEA Gift Card',             'Home & Electronics', 'home'),
    b('Urban Ladder',    'Urban Ladder Gift Card',     'Home & Electronics', 'home'),
    b('Home Centre',     'Home Centre Gift Card',      'Home & Electronics', 'home'),
    b('Havells',         'Havells Gift Voucher',       'Home & Electronics', 'home'),
    b('Philips',         'Philips Gift Card',          'Home & Electronics', 'home'),
    b('LG',              'LG Gift Voucher',            'Home & Electronics', 'home'),
    b('Samsung',         'Samsung Gift Card',          'Home & Electronics', 'home'),
    b('Sony',            'Sony Gift Card',             'Home & Electronics', 'home'),

    // 📚 Education / Services
    b('Udemy',           'Udemy Gift Card',            'Education', 'education'),
    b('Coursera',        'Coursera Voucher',           'Education', 'education'),
    b("Byju's",          "Byju's Learning Voucher",    'Education', 'education'),
    b('Unacademy',       'Unacademy Subscription',     'Education', 'education'),
    b('Simplilearn',     'Simplilearn Gift Card',      'Education', 'education'),

    // 🚗 Misc / Utility
    b('Uber',            'Uber Gift Card',             'Misc / Utility', 'utility'),
    b('Ola',             'Ola Money Voucher',          'Misc / Utility', 'utility'),
    b('Paytm',           'Paytm Gift Voucher',         'Misc / Utility', 'utility'),
    b('PhonePe',         'PhonePe Gift Card',          'Misc / Utility', 'utility'),
    b('Google Pay',      'Google Pay Voucher',         'Misc / Utility', 'utility')
];

export default dtShopBrands;
